import { TableColumn } from '../../../components/DataTable/TableColumn';
import { HepsiburadaOrder } from '../../../interfaces/Hepsiburada/HepsiburadaOrder';
import { TextColumn } from '../../../components/DataTable/TextColumn';
import { HepsiburadaStatusCell } from './HepsiburadaStatusCell';
import { DateColumn } from '../../../components/DataTable/DateColumn';
import { Pagination } from '../../../interfaces/Pagination';
import { DataTable } from '../../../components/DataTable/DataTable';

const columns: TableColumn<HepsiburadaOrder>[] = [
  {
    id: 'hepsiburada-id',
    name: 'Hepsiburada ID',
    accessor: (row) => <TextColumn value={row.hepsiburadaID} />,
  },
  {
    id: 'product-name',
    name: 'Ürün',
    accessor: (row) => <TextColumn value={row.productName} />,
  },
  {
    id: 'quantity',
    name: 'Miktar',
    accessor: (row) => <TextColumn value={row.quantity.toString()} />,
  },
  {
    id: 'status',
    name: 'Durum',
    align: 'center',
    accessor: (row) => <HepsiburadaStatusCell status={row.status} />,
  },
  {
    id: 'created-at',
    name: 'Sipariş Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
];

type HepsiburadaOrdersTableProps = {
  orders: HepsiburadaOrder[];
  totalCount: number;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
};

export const HepsiburadaOrdersTable = (props: HepsiburadaOrdersTableProps) => {
  return (
    <DataTable
      columns={columns}
      totalCount={props.totalCount}
      rows={props.orders}
      limit={props.pagination.pageSize}
      setLimit={(newLimit) =>
        props.onPagination({ page: 0, pageSize: newLimit })
      }
      page={props.pagination.page}
      setPage={(newPage) =>
        props.onPagination({ ...props.pagination, page: newPage })
      }
    />
  );
};
